import * as React from "react";

interface CopyCurlIconProps {
	color: string;
	hoverColor?: string;
	style: any;
	onMouseEnter?: () => void;
	onMouseLeave?: () => void;
	onClick?: () => void; // note: needed for "react-copy-to-clipboard" (the prop is overridden on render)
}

class CopyCurlIcon extends React.Component<CopyCurlIconProps, any> {
	constructor(props: CopyCurlIconProps) {
		super(props);
	}

	state = {
		color: "white", // default to white
	};

	componentWillMount() {
		this.setState({ color: this.props.color });
	}

	addHoverColor(e) {
		const { color, hoverColor } = this.props;
		const newColor = hoverColor || color;
		this.setState({ color: newColor });

		if (this.props.onMouseEnter) {
			this.props.onMouseEnter(); // fire the prop passed from the parent
		}
	}

	removeHoverColor(e) {
		this.setState({ color: this.props.color });

		if (this.props.onMouseLeave) {
			this.props.onMouseLeave(); // fire the prop passed from the parent
		}
	}

	render() {
		const { style, onClick } = this.props;

		const { color } = this.state;

		return (
			<svg
				width="38px"
				height="38px"
				viewBox="3 0 25 38"
				version="1.1"
				style={{
					fill: color,
					transition: "all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms",
					...style,
				}}
				onClick={onClick}
				onMouseOver={this.addHoverColor.bind(this)}
				onMouseLeave={this.removeHoverColor.bind(this)}
			>
				<g id="Page-1" stroke="none" strokeWidth="1" fillRule="evenodd">
					<g id="06" transform="translate(-1104.000000, -858.000000)" fillRule="nonzero">
						<g id="Curl_Selected" transform="translate(1104.000000, 858.000000)">
							<path
								d="M5.03353846,21.7557252 C4.90017603,21.228827 4.84309036,20.6857693 4.864,20.1429008 C4.85126603,19.6118233 4.90825778,19.0813605 5.03353846,18.5648855 C5.36685271,17.4622083 6.41501782,16.7272709 7.57369231,16.7838168 C8.89784615,16.7838168 9.88,17.5380153 10.1401538,18.460458 C10.178199,18.5713819 10.2084763,18.6847817 10.2307692,18.7998473 C10.24032,18.8471255 10.2282118,18.896171 10.1977205,18.933714 C10.1672292,18.971257 10.1215065,18.993417 10.0729231,18.9941985 L9.48830769,19.0580153 C9.44283329,19.0693056 9.39465461,19.0599544 9.35681768,19.0324939 C9.31898074,19.0050333 9.29540029,18.9623045 9.29246154,18.9158779 C9.29017899,18.8627931 9.28134379,18.8101866 9.26615385,18.7592366 C9.05237519,18.0203354 8.34979929,17.5281852 7.57661538,17.5757252 C6.78438379,17.5313838 6.07803723,18.0672629 5.91338462,18.8375573 C5.82659255,19.270081 5.78738837,19.710679 5.79646154,20.1516031 C5.78406988,20.5964737 5.82330225,21.041282 5.91338462,21.4772519 C6.0730462,22.2521893 6.78076022,22.7940431 7.57661538,22.750687 C8.45353846,22.750687 9.10830769,22.2430534 9.25446154,21.5903817 C9.25933588,21.5693844 9.25933588,21.5475622 9.25446154,21.5265649 C9.2563393,21.4797072 9.27966506,21.4362621 9.31780828,21.4085792 C9.3559515,21.3808964 9.4047409,21.3720032 9.45030769,21.3844275 L10.0144615,21.4743511 C10.0630449,21.4751326 10.1087676,21.4972926 10.1392589,21.5348356 C10.1697502,21.5723787 10.1818585,21.6214241 10.1723077,21.6687023 C10.1723077,21.720916 10.146,21.7992366 10.1196923,21.8891603 C9.85661538,22.8899237 8.83646154,23.5803053 7.55323077,23.5803053 C6.3886795,23.6252538 5.34569835,22.8700017 5.03353846,21.7557252 Z"
								id="Shape"
							/>
							<path
								d="M11.9641538,20.6476336 L11.9641538,14.5241221 C11.9606021,14.4785114 11.9773201,14.4336392 12.0099167,14.4012914 C12.0425133,14.3689436 12.0877308,14.3523532 12.1336923,14.3558779 L12.7183077,14.3558779 C12.7642692,14.3523532 12.8094867,14.3689436 12.8420833,14.4012914 C12.8746799,14.4336392 12.8913979,14.4785114 12.8878462,14.5241221 L12.8878462,20.6737405 C12.8878462,21.9094656 13.7647692,22.7535878 15.0743077,22.7535878 C16.3838462,22.7535878 17.2607692,21.9094656 17.2607692,20.6737405 L17.2607692,14.5241221 C17.2572175,14.4785114 17.2739355,14.4336392 17.3065321,14.4012914 C17.3391287,14.3689436 17.3843461,14.3523532 17.4303077,14.3558779 L18.0149231,14.3558779 C18.0608846,14.3523532 18.106102,14.3689436 18.1386987,14.4012914 C18.1712953,14.4336392 18.1880133,14.4785114 18.1844615,14.5241221 L18.1844615,20.6476336 C18.1844615,22.4025954 16.9392308,23.5483969 15.0655385,23.5483969 C13.1918462,23.5483969 11.9641538,22.4025954 11.9641538,20.6476336 Z"
								id="Shape"
							/>
							<path
								d="M25.7230769,23.3250382 L23.8172308,19.319084 C23.8004274,19.2905489 23.7713132,19.2712876 23.7383077,19.2668702 L21.5518462,19.2668702 C21.5345453,19.2660312 21.5176926,19.2724849 21.5054444,19.2846395 C21.4931963,19.2967941 21.486693,19.3135183 21.4875385,19.330687 L21.4875385,23.2844275 C21.4910902,23.3300382 21.4743722,23.3749104 21.4417756,23.4072582 C21.409179,23.439606 21.3639616,23.4561964 21.318,23.4526718 L20.7333846,23.4526718 C20.6874231,23.4561964 20.6422056,23.439606 20.609609,23.4072582 C20.5770124,23.3749104 20.5602944,23.3300382 20.5638462,23.2844275 L20.5638462,14.5038168 C20.5602944,14.4582061 20.5770124,14.4133338 20.609609,14.3809861 C20.6422056,14.3486383 20.6874231,14.3320479 20.7333846,14.3355725 L24.0803077,14.3355725 C25.5856923,14.3355725 26.5941538,15.3363359 26.5941538,16.830229 C26.6546024,17.9596624 25.8766833,18.9643455 24.7613846,19.1972519 C24.7087692,19.1972519 24.7087692,19.2349618 24.7233846,19.2755725 L26.676,23.2525191 C26.7286154,23.3685496 26.676,23.4468702 26.5444615,23.4468702 L25.9393846,23.4468702 C25.849693,23.4508332 25.7656338,23.4034882 25.7230769,23.3250382 Z M21.4787692,15.2029008 L21.4787692,18.4517557 C21.4779238,18.4689245 21.4844271,18.4856486 21.4966752,18.4978032 C21.5089233,18.5099579 21.5257761,18.5164115 21.5430769,18.5155725 L23.9692308,18.5155725 C24.5943726,18.5412821 25.1834406,18.2249693 25.5037307,17.6915894 C25.8240209,17.1582096 25.8240209,16.4935461 25.5037307,15.9601663 C25.1834406,15.4267865 24.5943726,15.1104736 23.9692308,15.1361832 L21.5518462,15.1361832 C21.5316996,15.1336442 21.5115916,15.1411577 21.4981358,15.1562525 C21.48468,15.1713473 21.4796182,15.1920693 21.4846154,15.2116031 L21.4787692,15.2029008 Z"
								id="Shape"
							/>
							<path
								d="M28.5730769,23.2844275 L28.5730769,14.5241221 C28.5695252,14.4785114 28.5862432,14.4336392 28.6188398,14.4012914 C28.6514364,14.3689436 28.6966538,14.3523532 28.7426154,14.3558779 L29.3272308,14.3558779 C29.3731923,14.3523532 29.4184097,14.3689436 29.4510064,14.4012914 C29.483603,14.4336392 29.500321,14.4785114 29.4967692,14.5241221 L29.4967692,22.5824427 C29.4959238,22.5996115 29.5024271,22.6163356 29.5146752,22.6284903 C29.5269233,22.6406449 29.5437761,22.6470986 29.5610769,22.6462595 L34.1327692,22.6462595 C34.1787308,22.6427349 34.2239482,22.6593253 34.2565448,22.6916731 C34.2891414,22.7240209 34.3058594,22.7688931 34.3023077,22.8145038 L34.3023077,23.2815267 C34.3058594,23.3271374 34.2891414,23.3720097 34.2565448,23.4043575 C34.2239482,23.4367052 34.1787308,23.4532956 34.1327692,23.449771 L28.7426154,23.449771 C28.6971969,23.4531965 28.6525013,23.4369846 28.620014,23.4053012 C28.5875268,23.3736178 28.5704154,23.3295521 28.5730769,23.2844275 Z"
								id="Shape"
							/>
						</g>
					</g>
				</g>
			</svg>
		);
	}
}

export default CopyCurlIcon;



// WEBPACK FOOTER //
// ./src/components/Example/CopyCurlIcon.tsx